export class AvailableFeatureFlag
{
    name: string;
    featureName: string;
    description: string;
    isGloballyEnabled: boolean;
    isAvailableForSelection: boolean;

    constructor(ff: any) {
        this.name = ff.name;
        this.featureName = ff.featureName;
        this.description = ff.description;
        this.isGloballyEnabled = ff.isGloballyEnabled;
        this.isAvailableForSelection = ff.isAvailableForSelection;
    }
}
